<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/psp/daily-tasks'">
                Daily Tasks
              </a>
            </li>

            <li aria-current="page" class="breadcrumb-item active text-gray psp-breadcrumb">
              Add New Patient
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="title d-flex p-3 justify-content-between align-items-center">
      <h2>Add New Patient</h2>
      <div class="pointer" data-bs-toggle="modal" (click)="openFetchModal()"
        data-bs-target="#fetch-user-data">
        <span>
          <i class="fa fa-search"></i>
        </span>
        <span class="ftch-text"> Lookup User Data </span>
      </div>
    </div>
    <app-fetch-user-data-modal (fetchData)="receiveUser($event)">
    </app-fetch-user-data-modal>
    <div class="card-body">
      <form #addPatientForm="ngForm">
        <h2>Personal details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="full-name">
                Full Name
              </label>
              <input [(ngModel)]="newPatient.patientFullName" class="input form-control" id="full-name"
                placeholder="Full Name" required ngModel #fullName="ngModel" [disabled]="isPreFetched && user.fullName.length !== 0"
                appCheckValidity pattern="^[A-Za-z -]+$" [appCheckValidity]="fullName" type="text" name="patientName" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="company"> Company Name</label>

              <ng-select
                name="companyId" id="company" placeholder="Choose Company" dropdownPosition="bottom"
                [(ngModel)]="companyId"
                (change)="onCompanyChange($event)"
                [appCheckValidity]="company"
                appCheckValidity
                ngModel
                required
                #company
                [clearable]="false"
              >
                <ng-option *ngFor="let company of companies" [value]="company.id">
                  {{ company.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>


          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="program"> Program Name </label>
              <ng-select
                [disabled]="companyId === null"
                [(ngModel)]="newPatient.programId"
                (change)="onProgramChange()"
                id="program"
                name="program"
                placeholder="Select Program"
                required
                ngModel
                #program="ngModel"
                appCheckValidity
                [appCheckValidity]="program"
                [clearable]="false"
              >
                <ng-option *ngFor="let program of programList" [value]="program.id">
                  {{ program.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label class="form-control-label" for="nationalId" *ngIf="!passportIdToggleOn; else passportIdBlock">
                  National ID
                </label>
                <ng-template #passportIdBlock>
                  <label class="form-control-label" for="passportId">
                    Passport ID
                  </label>
                </ng-template>

                <label class="custom-toggle custom-toggle-default custom-toggle-95">
                  <input
                    type="checkbox"
                    name="isPassportId"
                    [checked]="passportIdToggleOn"
                    (change)="onNationalIdToggleChang()"
                    [disabled]="isPreFetched && (newPatient.patientPassportId || newPatient.patientNationalId)"
                  />
                  <span class="custom-toggle-slider rounded-circle" data-label-off="Passport Id"
                    data-label-on="National Id">
                  </span>
                </label>

              </div>
              <input *ngIf="!passportIdToggleOn; else passportIdInputBlock" 
                 [(ngModel)]="newPatient.patientNationalId"
                 (blur)="validateNationalId()"
                 (input)="validateNationalId()"
                 class="input form-control" 
                 id="nationalId" 
                 placeholder="National ID" 
                 required 
                 #nationalId="ngModel" 
                 [disabled]="isPreFetched && user.nationalId && user.nationalId?.length !== 0" 
                 type="text" 
                 name="nationalId" 
                 minlength="14" 
                 maxlength="14" />
              <ng-template #passportIdInputBlock>
                <input [(ngModel)]="newPatient.patientPassportId" class="input form-control" id="passportId"
                  placeholder="Passport ID" required ngModel #passportId="ngModel"
                  [disabled]="isPreFetched && user.passportId && user.passportId.length !== 0" appCheckValidity [appCheckValidity]="passportId"
                  type="text" name="passportId" />
              </ng-template>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="example-date-input">
                Date Of Birth
              </label>
              <input
                class="form-control"
                id="example-date-input"
                type="date"
                name="dob"
                [(ngModel)]="patientDateOfBirth"
                [value]="patientDateOfBirth"
                required
                ngModel
                #dob="ngModel"
                [disabled]="isPreFetched && user.birthdate !== null"
                appCheckValidity
                [appCheckValidity]="dob" />
            </div>
          </div>

          <div *ngIf="showRocheFields();" class="col-md-4" >
            <div class="form-group">
              <label class="form-control-label" for="medicalHistory">
                Subscription History
              </label>
              <input
              [(ngModel)]="newPatient.subscriptionHistory" class="input form-control"
              id="medicalHistory" placeholder="Subscription History"
              ngModel #medicalHistory="ngModel"
              appCheckValidity
              [appCheckValidity]="medicalHistory"
              maxlength="50"
              type="text" name="subscriptionHistory"
              (blur)="displayErrorInSubscriptionHistory=false"
              (input)="preventWhiteSpace($event)"
              (keydown)="PreventWhiteSpaceAndNotifyWhenExceedMaxChars($event)"/>
              <div *ngIf="displayErrorInSubscriptionHistory" class="input-errors">
                <p >You can write up to 50 characters only</p>
              </div>
            </div>
          </div>

        </div>

        <h2>Phone details</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="mobile-number">
                Mobile Number
              </label>
              <div class="input-group input-group-merge">
                <input
                  [(ngModel)]="newPatient.patientMobileNumber"
                  id="mobile-number"
                  name="phone"
                  class="form-control"
                  placeholder="Phone number"
                  type="text"
                  required
                  ngModel
                  #mobilePhone="ngModel"
                  [disabled]="isPreFetched && user.phone.length !== 0"
                  appCheckValidity
                  [appCheckValidity]="mobilePhone"
                  pattern="(01)[0-9]{9}"
                />

                <div class="input-group-append">
                  <span class="input-group-text" (click)="onCopy()">
                    <i class="ni ni-ungroup"> </i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h2>Location</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="city"> City </label>

              <select [value]="newPatient.patientCityId" (change)="onCityChange($event.target.value)"
                class="form-control" id="city" name="city" required [disabled]="isPreFetched && user.cityId !== null" ngModel
                #city="ngModel" appCheckValidity [appCheckValidity]="city">
                <option *ngFor="let city of cities" [value]="city.id">
                  {{ city.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="area"> Area </label>

              <ng-select
                name="area" id="area" dropdownPosition="bottom"
                [(ngModel)]="newPatient.patientAreaId"
                [appCheckValidity]="area"
                [disabled]="isPreFetched && user.areaId !== null"
                appCheckValidity
                ngModel
                required
                #area="ngModel" [clearable]="false"
              >
                <ng-option *ngFor="let area of areas" [value]="area.id">
                  {{  area.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>

        <hr />

        <h2>Subscription Details</h2>
        <div class="row"
          [style]="isInsulinProgramSelected()?'padding-bottom: 15px;':'padding-bottom: 30px;'">

          <div class="col-md-4">
            <app-upload-file 
            [acceptedFileTypes]="uploadFileTypes"
            [labelName]="'Upload Document'"
            (selectedFile)="onFileUploaded($event)"
            ></app-upload-file>
            <p style="font-size: 12px;">Max number of uploading documents is 10 with size 10 MBs and the allowed extensions are images and PDFs </p>
            </div>

          <div class="col-md-3">
            <button
            class="btn btn-primary ml-3" 
            style="margin-top: 30px;"
            placeholder="Clear" 
            (click)="clearDocuments()"
            [disabled]="uploadedDocuments?.length==0">
            Clear
            </button>
          </div>

          <div class="col-md-4" *ngIf="uploadedDocuments?.length>0">
            <p style="font-size: 15px;">Selected Documents:</p>
            <div *ngFor="let doc of uploadedDocuments">
              <span style="font-size: 12px;">{{ doc.name }}</span>
            </div>
          </div>
        </div>

        <div class="row" style="padding-bottom: 30px;" *ngIf="isInsulinProgramSelected()">

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="insulinType"> Insulin Types</label>

              <ng-select
                name="insulinType" placeholder="Choose Insulin Type" dropdownPosition="bottom"
                [(ngModel)]="newPatient.insulinTypeId"
                ngModel
                required
                [clearable]="false"
              >
                <ng-option *ngFor="let insulinType of insulinTypes" [value]="insulinType.id">
                  {{ insulinType.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="form-control-label" for="referralCenter"> Referral Centers</label>

              <ng-select
                name="referralCenter" placeholder="Choose Referral Center" dropdownPosition="bottom"
                [(ngModel)]="newPatient.referralCenterId"
                ngModel
                required
                [clearable]="false"
                [searchable]="true"
              >
                <ng-option *ngFor="let referralCenter of referralCenters" [value]="referralCenter.id">
                  {{ referralCenter.name }}
                </ng-option>
              </ng-select>
            </div>
          </div>

        </div>

        <h2>Physician Details</h2>
        <div *ngIf="showRocheFields(); else EvaLilly">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" >
                  Select Doctor Type
                </label>
                <ng-select name="rochType" placeholder="Select Roch Type" notFoundText="No Type Found" dropdownPosition="bottom"
                           [searchable]="false" [closeOnSelect]="true" [clearSearchOnAdd]="false" [virtualScroll]="true"
                           (change)="onRocheTypeChange($event)" [(ngModel)]="selectedRocheType" [clearable]="false">

                  <ng-option *ngFor="let pair of rocheTypes" [value]="pair.id">{{ pair.name }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" >
                  Select Doctor Code
                </label>
                <ng-select name="serialNumber" placeholder="Select Serial Number" notFoundText="No SerialNumber Found"
                           dropdownPosition="bottom" [searchable]="true" [closeOnSelect]="true" [clearSearchOnAdd]="false"
                           [virtualScroll]="true" (change)="onDoctorSerialNumberChange($event)" [(ngModel)]="selectedRocheSerialNumber" [clearable]="false">

                  <ng-option *ngFor="let item of serialNumbersByType" [value]="item">{{selectedRocheType}}-{{item}}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="full-name">
                  Doctor Name
                </label>
                <input name="doctorName" class="form-control input" type="text" [(ngModel)]="selectedRocheDoctor" required readonly>
              </div>
            </div>
          </div>

        </div>
        <ng-template #EvaLilly>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label">
                  Doctor Specialty
                </label>
                <app-doctor-specialty
                  (specialtyChanged)="specialtyId = Number.parseInt($event)"
                  [companyId]="companyId"
                ></app-doctor-specialty>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="doctor-name">
                  Doctor Name
                </label>
                <app-doctor-names-selector
                  [companyId]="companyId"
                  (doctorNameChanged)="newPatient.doctorName = $event"
                  [specialtyId]="specialtyId"
                ></app-doctor-names-selector>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group">
                <label class="form-control-label" for="hospital-name">
                  Hospital Name
                </label>
                <input
                  [(ngModel)]="newPatient.hospitalName"
                  name="hospitalName"
                  class="form-control"
                  id="hospital-name"
                  [required]="true"
                  appCheckValidity
                  [appCheckValidity]="hosName"
                  ngModel
                  minlength="3"
                  type="text"
                  #hosName="ngModel" />
              </div>
            </div>
          </div>
        </ng-template>

        <div class="row psp-action-button-container mt-4">
          <div class="col btns-block">
            <button class="btn bg-gray text-white" type="button" (click)="onReset(addPatientForm)">
              Cancel
            </button>
            <button class="btn btn-primary ml-3" type="button" [disabled]="!addPatientForm.valid"
              (click)="onAddNewPatient(addPatientForm)">
              Confirm
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
